<template>
  <div class="AddCard">
    <div class="PageHeader">
      <div class="title">
        <span v-if="step === 1" class="d-flex a-center" @click="goBack">
          <img src="../../assets/img/arrow-left.svg" />
          Kart Ekleme
        </span>
        <span v-else id="ChangeStep" @click="changeStep(1)" class="d-flex a-center">
          <img src="../../assets/img/arrow-left.svg" />
          <span v-html="subTitle"></span>
        </span>
      </div>
      <div v-if="step === 1" class="Steps">
        <span class="ActiveStep">02</span>/03
      </div>
    </div>
    <Step1 v-if="step === 1" @changeStep="changeStep" :with-rate="withRate" :with-tc="withTc" />
    <Step2 v-else @changeStep="changeStep" :with-rate="withRate" :with-tc="withTc" @goToStepOne="step=1"/>
  </div>
</template>
<script>
    import {mapGetters,mapActions} from "vuex"
export default {
  name: "AddCard",
  components: {
    Step1: () => import("./Step1"),
    Step2: () => import("./Step2")
  },
  data: () => ({
    step: 1,
    withTc: true,
    withRate: true //""false
  }),
  computed: {
    ...mapGetters({
      registerFlow:'getRegisterFlow'
    }),
    title() {
      return this.step === 1 ? "Kart Ekleme" : "Kart Ekleme Onay";
    },
    subTitle(){
      return this.registerFlow ? 'İşlem Onayla' : 'Kart Ekleme Onay'
    }
  },
  mounted() {
    this.setLoading(false);
    if(this.$route.params.withTc === false) {
      this.withTc = false;
    }
    //""this.withRate = !!this.$route.params.withRate;
  },
  methods: {
    ...mapActions({
      setLoading:'setLoading'
    }),
    changeStep(step) {
      this.step = step;
    },
    goBack() {
      //this.$router.push('/select-card');
      this.$router.back();
    }
  }
};
</script>